export function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

export function triggerChange(element) {
    let changeEvent = new Event('change')
    element.dispatchEvent(changeEvent)
}

export function isNull(value) {
    return value === null
}

export function refreshObject(obj) {
    return JSON.parse(JSON.stringify(obj))
}

export function isUndefined(value) {
    return typeof value === 'undefined' || value === undefined
}

export function isNumber(value) {
    return !isNaN(value) && isFinite(value)
}

export function isEmpty(value) {
    if (value == null) {
        return true
    }

    if (typeof value === 'string') {
        return value.trim().length === 0
    }

    if (typeof value === 'object') {
        return Object.keys(value).length === 0
    }

    return false
}

export function debounce(func, timeout = 500) {
    let timer
    return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            func.apply(this, args)
        }, timeout)
    }
}

export function updateLocalStorage(key, data) {
    localStorage.setItem(key, JSON.stringify(data))
}

export function convertCmToMetres(cm) {
    return cm / 100
}

export function getTier(tier) {
    // console.log('getTier:', tier)

    const tierMapping = {
        tier1: 't1',
        tier2: 't2',
        tier3: 't3',
        tier4: 't4',
        tier5: 't5',
    }

    return tierMapping[tier] || 't1'
}

// Retrieves input data from a form and returns it as a JSON object:
export function formToJSON(elements) {
    return [].reduce.call(
        elements,
        function (data, element) {
            data[element.name] = element.value
            return data
        },
        {}
    )
}
